<script setup lang="ts">
    import { computed, toRefs } from "vue";
    import { useStore } from "@/store";

    const store = useStore();

    // TODO Ändra till användning av type i materialModule i Vue3
    interface Material {
        id: number;
        artikelnummer: string;
        namn: string;
        leverantor: string;
        streckkod1: string;
        streckkod2: string;
        lokalt_artikelnummer: string;
    }

    const props = defineProps<{
        materialId: number;
        index: number;
    }>();

    const { materialId, index } = toRefs(props);

    const material = computed<Material>(() => store.getters["material/materialById"]({ id: materialId.value }));
</script>

<template>
    <div class="material-row">
        <span>{{ index }}.</span>
        <span class="namn">{{ material?.namn }}</span>
        <span class="artikelnummer">{{ material?.artikelnummer }}</span>
    </div>
</template>

<style lang="scss" scoped>
    .material-row {
        display: grid;
        grid-column: 1 / -1;
        grid-template-columns: subgrid;
        grid-auto-flow: column;
        grid-gap: 0.3rem;

        .artikelnummer {
            margin-left: 0.5rem;
        }
    }
</style>
